import { CriterePondere } from './CriterePondere';
export class TypeCrJugement {

	public critereCDC: string;

	public critereLibre: string[];

	public criterePondere: CriterePondere[];

	public criterePrix: string;

	public typeCritere: string;

	constructor() {
		this.critereCDC = null;
		this.critereLibre = null;
		this.criterePondere = null;
		this.criterePrix = null;
		this.typeCritere = '';
	}
}
